module.exports = __webpack_public_path__ + "static/HTML5_Balloon-031d32c120932e3d29e251e83b72b2a2.png";